import styled from 'foundations-theming/utils';
import { tableButtonStyles } from './tableButtonStyles';
export const RowHoverContainer = styled.tr.withConfig({
  displayName: "RowHoverContainer"
})(["cursor:pointer;", ""], tableButtonStyles);